// eslint-disable-next-line import/prefer-default-export
export const getDisplayUrl = (url) => {
  const urlLowercase = url.toLowerCase();
  let splitIndex: number;
  if (urlLowercase.indexOf('www') > -1) {
    splitIndex = urlLowercase.indexOf('www.') + 4;
  } else {
    splitIndex = urlLowercase.indexOf('://') > -1 ? urlLowercase.indexOf('://') + 3 : 0;
  }
  return urlLowercase.substring(splitIndex);
};

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
